import * as actions from "../actions";
import typeToReducer from 'type-to-reducer';

const iniState = {
  searching: false,
  error: false,
  result: null,
};

export const match = typeToReducer({
  [actions.VALIDATE_PERSON]: {
    PENDING: () => ({
      ...iniState,
      searching: true,
      error: false,
      result: null
    }),
    REJECTED: (state) => ({
      ...state,
      searching: false,
      error: true,
      result: null
    }),
    FULFILLED: (state, action) => ({
      ...state,
      searching: false,
      error: false,
      result: action.payload.data.response
    })
  }
}, iniState);
